import { render, staticRenderFns } from "./ForeignContractorRegistrationModalDetails.vue?vue&type=template&id=2c3b3356&scoped=true&"
import script from "./ForeignContractorRegistrationModalDetails.vue?vue&type=script&lang=ts&"
export * from "./ForeignContractorRegistrationModalDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b3356",
  null
  
)

export default component.exports